<template>
<div class="entry-comment" data-cx-clickarea="comment">
  <div class="entry-comment__block entry-comment-header" v-if="$pageType === 'entry'">
    <div class="comment-counter"><a :href="commentUrl" data-cx-clickarea="comment-totalcount-entry"><strong>{{commentsMaxLength}}</strong> 件のコメント</a></div>
    <div class="btn-comment-write"><a @click="commentWrite" data-cx-clickarea="comment-write-entry"><span class="icon-write"></span>コメントを書く</a></div>
  </div>

  <div class="entry-comment__block list-comment-header" v-if="$pageType === 'comment'">
    <div class="comment-counter"><strong>{{commentsMaxLength}}</strong> 件のコメント</div>
  </div>

  <div class="entry-comment__block">
    <comment-list v-if="$pageType === 'entry'"></comment-list>
    <router-view v-if="$pageType === 'comment'"></router-view>
  </div>

  <div class="entry-comment__block entry-comment-footer" v-if="$pageType === 'entry' && comments.length > 0">
    <a :href="commentUrl" class="btn-comment-read" data-cx-clickarea="comment-read-entry">みんなのコメントを読む</a>
  </div>
</div>
</template>

<script>
import commentList from '@/components/tmplate/commentList/commentList'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'entryComment',
  components: {
    'comment-list': commentList
  },
  computed: {
    ...mapState('commentsData', ['commentsLength', 'commentsMaxLength', 'comments']),
    ...mapState('userData', ['user']),
    commentUrl: function () {
      const setCommentUrl = location.href.replace(location.search, '').replace(location.hash, '') + '?ly=cm'
      return setCommentUrl
    }
  },
  methods: {
    ...mapActions('modal', ['siteloginModal', 'siteRankupModal']),
    commentWrite: function () { // コメント書き込むボタン
      // ロール判定 middle:画面遷移、low or id登録のみ:ランクアップモーダル、左記以外：ログインモーダル
      if (this.user.role === 'low' || this.user.role === 'middle') {
        location.href = location.href.replace(location.search, '').replace(location.hash, '') + '?ly=cm'
      } else if (this.user.idOnly) {
        this.siteRankupModal('newsComment')
      } else {
        this.siteloginModal('comment-list')
      }
    }
  }
}
</script>

<style lang="scss" src="./entryComment.scss"></style>



// WEBPACK FOOTER //
// src/entryComment.vue